// extracted by css-extract-rspack-plugin
export default {"card":"card-M4UI8g","cardZebra":"cardZebra-jR3ZUD","cardSelected":"cardSelected-HikcbO"};